// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Effect from "../Effect/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Unscramble from "../Unscramble/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var decode = /* #__PURE__ */ Foreign_Generic_Class.decode(Foreign_Generic_Class.stringDecode);
var fail = /* #__PURE__ */ Foreign.fail(Data_Identity.monadIdentity);
var pure = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity));
var UUID = function (x) {
    return x;
};
var unsafeDecodeUUIDFromString = function (str) {
    var $16 = $foreign.isValidUUID(str);
    if ($16) {
        return str;
    };
    return Unscramble.decodingError("Invalid UUID: " + show(str));
};
var ufromJSONKeyUUID = /* #__PURE__ */ (function () {
    return {
        fromJSONKey: new Unscramble.FromJSONKeyString(unsafeDecodeUUIDFromString)
    };
})();
var udecodeUUID = {
    unsafeDecode: function ($22) {
        return unsafeDecodeUUIDFromString(Unscramble.decodeString($22));
    }
};
var toString = function (v) {
    return v;
};
var showUUID = {
    show: toString
};
var ordUUID = Data_Ord.ordString;
var genUUID = /* #__PURE__ */ Data_Functor.map(Effect.functorEffect)(UUID)($foreign["_genUUIDImpl"]);
var fromString = function (str) {
    if ($foreign.isValidUUID(str)) {
        return new Data_Maybe.Just(str);
    };
    if (Data_Boolean.otherwise) {
        return Data_Maybe.Nothing.value;
    };
    throw new Error("Failed pattern match at Data.UUID (line 49, column 1 - line 49, column 35): " + [ str.constructor.name ]);
};
var forceFromString = function (str) {
    return Data_Maybe["fromMaybe$prime"](function (v) {
        return Partial_Unsafe.unsafeCrashWith("Invalid UUID: " + show(str));
    })(fromString(str));
};
var eqUUID = Data_Eq.eqString;
var encodeUUID = {
    encode: /* #__PURE__ */ (function () {
        var $23 = Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode);
        return function ($24) {
            return $23(toString($24));
        };
    })()
};
var decodeUUID = {
    decode: function (f) {
        return bind(decode(f))(function (v) {
            var v1 = fromString(v);
            if (v1 instanceof Data_Maybe.Nothing) {
                return fail(new Foreign.ForeignError("Invalid UUID: " + show(v)));
            };
            if (v1 instanceof Data_Maybe.Just) {
                return pure(v1.value0);
            };
            throw new Error("Failed pattern match at Data.UUID (line 30, column 5 - line 32, column 23): " + [ v1.constructor.name ]);
        });
    }
};
export {
    fromString,
    forceFromString,
    genUUID,
    toString,
    showUUID,
    eqUUID,
    ordUUID,
    encodeUUID,
    decodeUUID,
    udecodeUUID,
    ufromJSONKeyUUID
};
